import {Component, inject, input, Input, PLATFORM_ID} from '@angular/core';
import {LpCtaComponent} from "../../common/lp/lp-cta/lp-cta.component";
import {DOCUMENT, NgIf} from '@angular/common';
import {ActivatedRoute} from '@angular/router';
import {SocialTrackService} from '../../../../services/social-track.service';


@Component({
  selector: 'app-home-program',
  imports: [
    LpCtaComponent,
    NgIf
  ],
  templateUrl: './home-program.component.html',
})
export class HomeProgramComponent {

  sessionId = input<string>();
  route = inject(ActivatedRoute)
  platformId = inject(PLATFORM_ID);
  document = inject(DOCUMENT);
  socialTrackService = inject(SocialTrackService);

  @Input()
  showPhotos = true

  @Input()
  isForWomenOnly = false

  goToEvents() {
    const homeEvents = this.document.getElementById('home-events')
    homeEvents.scrollIntoView({ behavior: 'smooth' });
  }

}
